import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { ApiUrl } from '../constants/apiUrl';
import { ContractType } from '../models/entities/contract-type';
import { VContractType } from '../models/entities/v-contract-type';
import { ListResponseModel } from '../models/responseModels/list-response-model';
import { ObjectResponseModel } from '../models/responseModels/object-response-model';
import { ResponseModel } from '../models/responseModels/response-model';

@Injectable({
  providedIn: 'root'
})
export class ContractTypeService {

  constructor(private httpClient: HttpClient, private router: Router, private toastrService: ToastrService) { }

  getList(): Observable<ListResponseModel<VContractType>> {
    return this.httpClient.get<ListResponseModel<VContractType>>(ApiUrl.url + "ContractType/getList");
  }

  getById(id: number): Observable<ObjectResponseModel<ContractType>> {
    return this.httpClient.get<ObjectResponseModel<ContractType>>(ApiUrl.url + "ContractType/getById?Id=" + id);
  }


  add(contractType: ContractType) {
    return this.httpClient.post<ObjectResponseModel<ContractType>>(ApiUrl.url + "ContractType/add", contractType);
  }

  update(contractType: ContractType) {
    return this.httpClient.post<ResponseModel>(ApiUrl.url + "ContractType/update", contractType);
  }

  delete(id: number) {
    return this.httpClient.post<ResponseModel>(ApiUrl.url + "ContractType/delete?Id=" + id, "");
  }


}
